export default __webpack_public_path__ + "static/media/info.af0d9da1.svg";